var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70344 18.3281V10.4144H0.0234375V7.33021H2.70344V5.05575C2.70344 2.41626 4.32577 0.979004 6.6953 0.979004C7.83033 0.979004 8.80583 1.06298 9.09011 1.10051V3.85894L7.44672 3.85968C6.15803 3.85968 5.90851 4.46818 5.90851 5.36113V7.33021H8.9819L8.58173 10.4144H5.90851V18.3281H2.70344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.c397625f0d5c7dae358b013042473493.svg";
export { ForwardRef as ReactComponent };